import SeoHead from '../../components/SeoHead';
import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
// import { Collection } from "@sourceflow-uk/sourceflow-sdk"
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import SimplePage from '../../components/SimplePage';
import AllLocations from '../../components/AllLocations';
import Header from '../../components/MainHeader';

export default function JobSeekersGetInTouch({
    global,
    all_region_locations,
    all_locations
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Job Seekers - Get in touch | Gap Personnel`}
                // description={`Get in touch with Driving Force to discuss your driving job requirements by phone on 0845 634 1161 or email: marketing@driving-force.co.uk`}
                canonical_link={`/job-seekers-get-in-touch/`}
            />
            <Header
                employerNav={false}
            />
            <SubBanner
                global={global}
                pathPrefix={`job_seekers_get_in_touch_page.sub_banner`}
                customClass={`mb-5 secondary-banner get-in-touch`}
                buttonTitle={`Jobseekers`}
                buttonLink={`/job-seekers/`}
                heading={`Get in touch`}
                bannerImage="/site-assets/images/jobseeker-contact.jpg"
                bannerImageAlt="Jobseekers Get in touch"

            />
            <SimplePage
                global={global}
                pathPrefix={`job_seekers_get_in_touch_page.simple_page_1`}
                customClass={``}
                content={
                    <>
                        <h5>Our branches offer regional coverage.</h5>
                        <p>Get in touch with the team who are most local to you; either give them a call or drop your message in the get in touch form.</p>
                    </>
                }
                textCenter={true}
            />
            <AllLocations
                global={global}
                pathPrefix={`job_seekers_get_in_touch_page.all_locations`}
                all_locations={all_locations}
                all_region_locations={all_region_locations}
                customClass={`mt-5`}
            />
            <SimplePage
                global={global}
                pathPrefix={`job_seekers_get_in_touch_page.simple_page_2`}
                customClass={``}
                content={``}
                formId={`8b0cfaf0-9698-40f3-ab7a-bd588c2c22ca`}
                heading={`Get in touch`}
                textCenter={true}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const locations = await Collection('locations');

    // Pulls parent region only.
    const all_region_locations = locations.orderBy('order')
        .getItems().filter(sector =>
            (sector.parent.identifier === null));
    // Pulls children region only.
    const all_locations = locations.orderBy('order')
        // .getItems().filter(sector =>
        //     (sector.parent.identifier != null));
        .getItems().filter(sector => !sector.hide_on_job_seekers_page);

    return {
        props: {
            global,
            all_region_locations,
            all_locations
        },
    }
}